"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const silo_pos_style_1 = __importDefault(require("../silo-pos.style"));
const silo_pos_action_1 = __importDefault(require("../silo-pos.action"));
const modal_1 = require("components/molecules/modal");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const svg_1 = require("components/atoms/svg");
const authorization_1 = require("utils/authorization");
const SiloPos = () => {
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const { isLoading, isError, errorMessage } = (0, store_1.useAppSelector)((state) => state.siloPos);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Silo');
    const accessOperatorSilo = (0, authorization_1.userOperatorAccess)(userData.operator_access, 'Silo');
    const { operatorAccessSilo1, operatorAccessSilo2, operatorAccessSilo3, operatorAccessSilo4 } = (0, authorization_1.operatorAccessSilo)(accessOperatorSilo);
    (0, react_1.useEffect)(() => {
        widthCheker();
        if (!isAuthorized.view)
            navigate('/dashboard', { replace: true });
    }, [isAuthorized]);
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    window.onload = widthCheker;
    window.onresize = widthCheker;
    const handleChoosePos = (arg) => {
        const operatorAccess = arg.operator_access;
        if (operatorAccess.has_access) {
            if (operatorAccess.checkpoint_child) {
                const [{ checkpoint_id }] = operatorAccess.checkpoint_child;
                dispatch(silo_pos_action_1.default.toggleLoading({ isLoading: true }));
                dispatch(silo_pos_action_1.default.getLandingPageSilo({
                    checkpoint_id: process.env.CHECKPOINT_ID != '-' ?
                        String(process.env.CHECKPOINT_ID) :
                        checkpoint_id
                }));
                dispatch(silo_pos_action_1.default.setSelectedChild({
                    checkpointChild: process.env.CHECKPOINT_ID != '-' ?
                        operatorAccess.checkpoint_child.filter(i => i.checkpoint_id == process.env.CHECKPOINT_ID) :
                        operatorAccess.checkpoint_child
                }));
                setTimeout(() => {
                    navigate('/silo');
                }, 1000);
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            width: fullScreen ? 'auto' : 'max-content',
            height: 'inherit',
        } }, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'Choose SILO', theme: appTheme, isLoading: isLoading }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: silo_pos_style_1.default.choosePosContainer(appTheme) }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: operatorAccessSilo1.has_access ? silo_pos_style_1.default.availablePos : silo_pos_style_1.default.unavailablePos, onClick: () => handleChoosePos({ operator_access: operatorAccessSilo1 }) }, { children: (0, jsx_runtime_1.jsx)(svg_1.SiloPosIcon1, { disabled: !operatorAccessSilo1.has_access }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: operatorAccessSilo2.has_access ? silo_pos_style_1.default.availablePos : silo_pos_style_1.default.unavailablePos, onClick: () => handleChoosePos({ operator_access: operatorAccessSilo2 }) }, { children: (0, jsx_runtime_1.jsx)(svg_1.SiloPosIcon2, { disabled: !operatorAccessSilo2.has_access }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: operatorAccessSilo3.has_access ? silo_pos_style_1.default.availablePos : silo_pos_style_1.default.unavailablePos, onClick: () => handleChoosePos({ operator_access: operatorAccessSilo3 }) }, { children: (0, jsx_runtime_1.jsx)(svg_1.SiloPosIcon3, { disabled: !operatorAccessSilo3.has_access }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: operatorAccessSilo4.has_access ? silo_pos_style_1.default.availablePos : silo_pos_style_1.default.unavailablePos, onClick: () => handleChoosePos({ operator_access: operatorAccessSilo4 }) }, { children: (0, jsx_runtime_1.jsx)(svg_1.SiloPosIcon4, { disabled: !operatorAccessSilo4.has_access }) }))] })), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => {
                    dispatch(silo_pos_action_1.default.toggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                } })] })));
};
exports.default = SiloPos;
